module.exports = ".tags-container {\n  margin-top: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/series/detail-view/detail-view.style.scss
// module id = 812
// module chunks = 2